import { normalizeTenantIdList } from "helpers/couponScopeOptions";
import {
  getSelectedCurrencyIdsFromTenants,
  syncCurrencySettings,
} from "helpers/couponDiscountType";

export const applyVerticalScopeChange = (previousValues, nextVerticalId) => ({
  ...previousValues,
  verticalId: nextVerticalId,
  tenantIds: [],
  currencyId: "",
  currencySettings: {},
  minimumPackageMrp: "",
  minimumCartMrp: "",
  selectAllPackages: false,
  packageIds: [],
});

export const applyTenantsScopeChange = (previousValues, nextTenantIds) => ({
  ...previousValues,
  tenantIds: normalizeTenantIdList(nextTenantIds),
  selectAllPackages: false,
  packageIds: [],
});

export const applyConfirmedTenantScope = (
  previousValues,
  { tenantsForVertical = [] } = {}
) => {
  const normalizedTenantIds = normalizeTenantIdList(previousValues.tenantIds);
  const currencyIds = getSelectedCurrencyIdsFromTenants(
    tenantsForVertical,
    normalizedTenantIds
  );

  return {
    ...previousValues,
    tenantIds: normalizedTenantIds,
    currencyId: currencyIds.length === 1 ? currencyIds[0] : "",
    currencySettings: syncCurrencySettings(
      previousValues.currencySettings,
      currencyIds
    ),
    selectAllPackages: false,
    packageIds: [],
  };
};

export const VERTICAL_SCOPE_ERROR_FIELDS = [
  "verticalId",
  "tenantIds",
  "currencyId",
  "currencySettings",
  "minimumPackageMrp",
  "minimumCartMrp",
  "packageIds",
  "selectAllPackages",
];

export const TENANT_SCOPE_ERROR_FIELDS = [
  "tenantIds",
  "currencyId",
  "currencySettings",
  "packageIds",
  "selectAllPackages",
];

export const DISCOUNT_TYPE_SCOPE_ERROR_FIELDS = [
  "currencySettings",
  "minimumPackageMrp",
  "minimumCartMrp",
  "maxAllowedAmount",
  "discountValue",
];
